import { createFeatureSelector, createSelector } from '@ngrx/store';

export const ACCOUNT_SELECTION_FEATURE = 'accountSelection';
export const accountSelector = createSelector(createFeatureSelector<any>(ACCOUNT_SELECTION_FEATURE), state => state);
